import React, { useEffect, useRef, useState } from "react"

import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { faFileAlt, faInfo, faPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"

import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_USERSETING_PARAMS, ENUM_USERSETING_SETVALUE, FixHeight, FixMobileHeight, FixScreenHeight, GetLoginCredentialDb, getModValue, linksUrl } from "../constants/enum.js"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NextUITable,

} from "../components/index.js"
import { useFetchWithBody, usePost, usePostLogin, usePostMutateWithSuccess } from "../api/reactQueryCustomHooks.jsx"
import { resetCompCode, setAppType, setCompCode, setCompInfo, setCurrencyType, setReload, setSalePerson } from "../state/companySlice.jsx"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, TOP_ACTION_BTN_TYPE } from "../components/NextUITable.jsx"
import { addToast, Button, Card, CardBody } from "@heroui/react"
import { setLogout } from "../state/authSlice.jsx"
import { useQueryClient } from "@tanstack/react-query"
import { isMobile } from "react-device-detect"
import { setDetailParams, setNewEntryMode } from "../state/orderSlice.jsx"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { format, toDate } from "date-fns"
import { Box, Typography } from "@mui/material"

const DashBoard = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { yearId, compCode, compName } = useSelector((state) => state.company)
    const { user } = useSelector((state) => state.auth)
    const queryClient = useQueryClient()
    const [compData, setCompData] = useState([])
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [orderDate, setOrderDate] = useState({
        fromDate: frDate(new Date()),
        toDate: frDate(new Date())
    });
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };
    const { data: ordData = [], mutate: filterOrder } = usePost({
        url: apiRoute.saleOrder.getOrder,
        queryKey: "getreportOrderdata"

    })
   

 
    const funLoadData = (fdate, tdate) => {
        filterOrder({
            data: {
                comp_code: compCode.join(","),
                pac_id: null,
                bill_type: 'S',
                uid: user.isadmin == 1 ? null : user.username,
                fdate: fdate,
                tdate: tdate
            }
        })
    }
    useEffect(() => {
        if (compCode != null && compCode != "") {
            funLoadData(orderDate?.fromDate, orderDate?.toDate)
        }
    }, [compCode])
    const handleNewOrder = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.salesOrder.createEntry);
    }

    const INITIAL_VISIBLE_COLUMNS = ["Ord_No", "Ord_Date", "Party", "Ord_Qty", "Amount"]

    const columns = [
        { header: "Ord No.", accessor: "Ord_No", type: "text", filterable: true, sortable: true, align: "center" },
        { header: "Date", accessor: "Ord_Date", type: "date", filterable: true, sortable: true, align: "center" },
        { header: "Party", accessor: "Party", type: "text", filterable: true, sortable: true },
        { header: "Qty", accessor: "Ord_Qty", type: "number", filterable: true, sortable: true, align: "right" },
        { header: "Amount", accessor: "Amount", type: "number", filterable: true, sortable: true, align: "right" },
        // { name: "Ord No.", uid: "Ord_No", sortable: true, align: COLUMN_ALIGN_TYPE.left },
        // { name: "Date", uid: "Ord_Date", sortable: true, align: COLUMN_ALIGN_TYPE.left, type: COLUMN_TYPE.date },
        // { name: "Party", uid: "Party", sortable: true, align: COLUMN_ALIGN_TYPE.left },
        // { name: "Qty", uid: "Ord_Qty", sortable: true, align: COLUMN_ALIGN_TYPE.left, type: COLUMN_TYPE.number },
        // { name: "Amount", uid: "Amount", sortable: true, align: COLUMN_ALIGN_TYPE.left, type: COLUMN_TYPE.number },
    ]
    const handleOnclick = () => {
        dispatch(setLogout())
        dispatch(resetCompCode())
        queryClient.removeQueries()
        navigate(linksUrl.login)
    }
    const handleFilter = () => {
        funLoadData(orderDate?.fromDate, orderDate?.toDate)
    }
    const handleClear = () => {
        setOrderDate({ fromDate: frDate(new Date()), toDate: frDate(new Date()) })
        funLoadData(frDate(new Date()), frDate(new Date()))
    }
    return (
        <MainContainer pageName="Home" info={[]} breadcrumbs={["Home"]}>
            <Card>
                <CardBody className=""
                    style={{ height: isMobile ? FixMobileHeight : FixScreenHeight }}
                >
                    {/* <MyComponent items={items}  /> */}
                     {user?.isadmin == 1?"":
                    <div className=" flex justify-end">
                        <Button size="md" radius="sm" color="success" variant={"flat"} onPress={handleNewOrder}
                            className=" h-8 border-0 text-sm uppercase  font-semibold bg-gradient-to-t from-lime-700 to-lime-500  text-white"
                            startContent={<FontAwesomeIcon className="text-md" icon={faFileAlt} />}>New Order</Button>
                    </div>}


                    <div className="bg-white p-2 h-screen">

                        <div className="p-2 shadow mb-0">
                            {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                            <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                                <div className="flex no-wrap gap-5 mt-3">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"From Date"}
                                            views={["day", "month", "year"]}
                                            size="small"
                                            format="DD/MM/YYYY"
                                            value={
                                                orderDate.fromDate
                                                    ? dayjs(orderDate.fromDate)
                                                    : orderDate.fromDate
                                            }
                                            onChange={(newValue) => {
                                                setOrderDate((prev) => {
                                                    return {
                                                        ...prev,
                                                        fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                                    };
                                                });
                                            }}
                                            slotProps={{
                                                textField: { size: "small", },
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"To  Date"}
                                            views={["day", "month", "year"]}
                                            format="DD/MM/YYYY"
                                            size="small"
                                            value={
                                                orderDate.toDate
                                                    ? dayjs(orderDate.toDate)
                                                    : orderDate.toDate
                                            }
                                            onChange={(newValue) => {
                                                setOrderDate((prev) => {
                                                    return {
                                                        ...prev,
                                                        toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                            dayjs(newValue).format("YYYY-MM-DD") : null,
                                                    };
                                                });
                                            }}
                                            slotProps={{
                                                textField: { size: "small", },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="flex no-wrap gap-5 justify-center items-center">
                                    <Button onPress={handleFilter} className="font-semibold uppercase bg-red-700 text-white" variant="solid" color="primary" size="sm" >Get Order</Button>
                                    <Button onPress={handleClear} className="font-semibold uppercase bg-gray-600" variant="solid" color="danger" size="sm" >Reset Date</Button>
                                </div>
                            </div>
                        </div>

                        <div className="pt-5">
                            {ordData && ordData.length > 0 ?

                                <MasterGrid
                                    columns={columns}
                                    data={ordData}
                                    className={""}
                                    showPaging={true}
                                    pageSize={20}
                                    expandableRow={false}
                                    headClass={"bg-slate-700 border-1 border-slate-300 text-white uppercase text-xs"}
                                    filterClass={"bg-slate-100 border-1 border-slate-300"}
                                    style={{ border: "1px solid red" }}
                                    exportHeader={{
                                        companyName: compName.join(","),
                                        reportName: `Date Wise Order Detail From ${formatDate(orderDate.fromDate)} To ${formatDate(orderDate.toDate)}`,

                                    }}
                                ></MasterGrid> : <Box sx={{
                                    p: 4,
                                    textAlign: 'center',
                                    border: `1px dashed gray`,
                                    borderRadius: 2,
                                    backgroundColor: 'background.default'

                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2
                                    }}>
                                        <FontAwesomeIcon icon={faInfo} />
                                        {/* <DescriptionOutlined sx={{
                                  fontSize: 48,
                                  color: 'text.disabled'
                                }} /> */}
                                        <Typography variant="h6" color="text.secondary">
                                            No  data available
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            Apply filters above to generate a report
                                        </Typography>
                                    </Box>
                                </Box>}                {/* <NextUITable
                  INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                  data={ordData}
                  columns={columns}
                  exportColumns={columns}
                  //topActionBtn={topActionBtn}
                   downloadDataFooter={downloadDataFooter}
                  downloadFileName="Order List"
                  showAdvanceFilter={false}
                  id="Ord_No"
                  rowSelection={false}

                /> */}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </MainContainer>
    )
}
export default DashBoard